import { Component, Input, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { BarChartDataItem, BarChartXAxis, BarChartYAxis, PieChartDataItem } from '../../../charts/chart.models';
import { Subject } from 'rxjs';
import {
  CommunicationRecipientStatus,
  MassNotification,
  MassNotificationResponseOverTime,
  MassNotificationStats
} from 'src/app/modules/communications/store/communications/communications.model';
import { v4 as uuidv4 } from 'uuid';
import { ChannelSelectionService } from 'src/app/modules/communications/services/channel-selection-service';
import { TranslateService } from '@ngx-translate/core';
import { NotificationStatusService } from 'src/app/modules/communications/services/notification-status-service';
import { CommunicationsApiService } from 'src/app/modules/communications/store/communications/communications-api.service';
import moment from 'moment';
@Component({
    selector: 'topo-comms-notification-responses-over-time-chart-widget',
    templateUrl: './responses-over-time-chart-widget.component.html',
    styleUrls: ['./responses-over-time-chart-widget.component.scss'],
    standalone: false
})
export class ResponsesOverTimeChartWidgetComponent implements OnInit, OnDestroy {
  data: BarChartDataItem[];
  showLegend: boolean = true;
  showPercentage: boolean = false;
  countLabel?: string;
  dataLabel?: string;
  barTypes: Array<string> = ['bar'];
  barYAxis: Array<BarChartYAxis> = [];
  barXAxis: Array<BarChartXAxis> = [];
  colorPerBar: boolean;
  xGap = 1;
  colors?: any = {
    axisColor: '#7257FF',
    labelColor: '#f0f0f0',
    titleColor: '#f0f0f0'
  };
  private destroy$ = new Subject<void>();

  @Input() width: string;

  @Input() notification: MassNotification;

  @Input() set notificationStats(value: MassNotificationStats) {
    this.data = [];
    if (!!!value?.responsesStats?.responses) {
      return;
    }
    const ranges: { fromTime: moment.Moment; toTime: moment.Moment }[] = [];

    const ctime = new Date(this.notification?.createdOn);
    ctime.setSeconds(0);
    ctime.setMilliseconds(0);
    ctime.setMinutes(Math.floor(ctime.getMinutes() / 10) * 10);
    let time = moment(ctime);

    let dispTime = moment(new Date(2000, 1, 0, 0, 0));

    this.xGap = 3;
    for (var i = 0; i < 48; i++) {
      const ntime = time.clone();
      ntime.add(10, 'minutes');
      const data = {
        id: time.toString(),
        data: [],
        label: dispTime.format('HH:mm'),
        label2: null
      };
      data.data.push({
        id: time.toString(),
        count: 0,
        color: '#82C91E',
        textColor: '#404040',
        label: dispTime.format('HH:mm')
      });
      ranges.push({
        fromTime: time,
        toTime: ntime
      });
      this.data.push(data);

      time = ntime;
      dispTime.add(10, 'minutes');
    }

    value?.responsesStats?.responses.forEach(r => {
      const rtime = moment(r.time);
      const index = ranges.findIndex(g => rtime.isBetween(g.fromTime, g.toTime, undefined, '[)'));
      if (index >= 0) {
        this.data[index].data[0].count += r.responseCount;
      }
    });
  }

  @ViewChild('canvas') canvas: ElementRef;

  constructor() {}

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  selected(data: { item: BarChartDataItem; subValue: any }): void {}
}
